import { useTranslation } from 'react-i18next';
import { useLocation,useNavigate,useOutletContext } from "react-router-dom"

import { Button } from "primereact/button";
import { Tooltip } from 'primereact/tooltip';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useContext, useEffect, useState } from 'react';
import { SystemLoading, checkLoading } from '../../store/loadingStore';
import { getAuditLogDetail } from '../../utility/service/audilog-service';
import { downloadAuditLogFile } from '../../utility/service/download-service';

const AccountActivityDetail = () => {
    const { setAction, action, setItemObj, itemObj,setCurrentStatus } = useOutletContext();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [dataState, setDataState] = useState(false);
    const [, loading] = useContext(SystemLoading);
    const [expandData,setExpandData] = useState([]);
    const [disableExpand,setDisableExpand] = useState(false);
    const location = useLocation();



    useEffect(()=>{
        if(JSON.stringify(itemObj)==='{}'){
          navigate(-1)
        }
      },[itemObj])

      const axios_getAuditLogDetail = (reqBody)=>{
        checkLoading(loading);
        getAuditLogDetail(reqBody).then((res)=>{
          if(res.data.ResHeader.rtnCode === '1100'){
            setExpandData(res.data.RespBody.dataList);
            setDisableExpand(true);
          }else{
            setDisableExpand(true);
          }
        }).finally(() => checkLoading(loading, false))
      }

      
      const btnExpandDetail = ()=>{ //展開明細
        let reqBody = {
          txnUid:itemObj.txnUid
        }
        axios_getAuditLogDetail(reqBody);

      } 

      const btnBackTo = ()=>{
          setCurrentStatus({dataList:location.state.dataList,
            startDate:location.state.startDate,
            endDate:location.state.endDate,
            back:"Y"});
          navigate("/management/accountActivity");
     
      }
      

    return (
        <>
            {/* 返回上頁 */}
            <div className="flex justify-content-between flex-wrap align-items-center">
                <div className="align-items-start">
                    <Button rounded text onClick={() => { btnBackTo(); }}>
                        <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
                        {t('button.return_to_list')}
                    </Button>
                </div>
            </div>
            {/* 檢視區塊 */}
            <div className='p-card'>
                <div className="p-card-body">
                    <div className='grid'>
                        {/* 軌跡編號 */}
                        <div className='col-12 lg:col-6'>
                            <label
                                className="form-label">
                                {t("audit_id")}
                            </label>
                            <span>{itemObj?.auditLongId}</span>
                        </div>
                        {/* 事件發生時間 */}
                        <div className='col-12 lg:col-6'>
                            <label
                                className="form-label">
                                {t("event_create_datetime")}
                            </label>
                            <span>{itemObj?.createDateTime}</span>
                        </div>
                    </div>
                    <hr />
                    <div className='grid'>
                        {/* 主機 UUID */}
                        <div className='col-12'>
                            <label
                                className="form-label">
                                {t("host_uuid")}
                            </label>
                            <span>{itemObj?.txnUid}</span>
                        </div>
                        {/* API URL */}
                        <div className='col-12'>
                            <label
                                className="form-label">
                                {t("api_url")}
                            </label>
                            <span>{itemObj?.apiUrl}</span>
                        </div>
                        {/* ID Token */}
                        <div className='col-12'>
                            <label className="form-label">ID Token</label>
                            <span className='token-code-area'>
                                {itemObj?.idToken}
                            </span>
                        </div>
                    </div>
                    <hr />
                    <div className='grid'>
                        {/* 用戶端帳號 */}
                        <div className='col-12 lg:col-4'>
                            <label
                                className="form-label">
                                {t("client_id")}
                            </label>
                            <span>{itemObj?.clientId}</span>
                        </div>
                        {/* 使用者名稱 */}
                        <div className='col-12 lg:col-4'>
                            <label
                                className="form-label">
                                {t("user_name")}
                            </label>
                            <span>{itemObj?.userName}</span>
                        </div>
                        {/* API 事件 */}
                        <div className='col-12 lg:col-4'>
                            <label
                                className="form-label">
                                {t("api_event")}
                            </label>
                            <span>{itemObj?.eventName}</span>
                        </div>
                        {/* 使用者 IP */}
                        {/* <div className='col-12 lg:col-4'>
                            <label
                                className="form-label">
                                {t("user_ip")}
                            </label>
                            <span>{itemObj?.userIp}</span>
                        </div> */}
                        {/* 使用者主機名稱 */}
                        {/* <div className='col-12 lg:col-8'>
                            <label
                                className="form-label">
                                {t("user_hostname")}
                            </label>
                            <span>{itemObj?.userHostname}</span>
                        </div> */}
                        {/* 使用者角色 */}
                        <div className='col-12 lg:col-4'>
                            <label
                                className="form-label">
                                {t("user_role")}
                            </label>
                            <span>{itemObj?.userRole}</span>
                        </div>
                        {/* 使用者角色 */}
                        <div className='col-12 lg:col-4'>
                            <label
                                className="form-label">
                                {t("account_type")}
                            </label>
                            <span>{itemObj?.acctTypeName}</span>
                        </div>
                   
                        {/* 參數1-5 有值才出現 */}
                        {
                            itemObj?.param1 && itemObj?.param1?.length>0 && (
                                <div className='col-12'>
                                    <label
                                        className="form-label">
                                        {t("param.1")}
                                    </label>
                                    <span>{itemObj?.param1}</span>
                                </div>
                                
                            )
                        }
                        {
                            itemObj?.param2 && itemObj?.param2?.length>0 && (
                                <div className='col-12'>
                                    <label
                                        className="form-label">
                                        {t("param.2")}
                                    </label>
                                    <span>{itemObj?.param2}</span>
                                </div>
                                
                            )
                        }
                        {
                            itemObj?.param3 && itemObj?.param3?.length>0 && (
                                <div className='col-12'>
                                    <label
                                        className="form-label">
                                        {t("param.3")}
                                    </label>
                                    <span>{itemObj?.param3}</span>
                                </div>
                                
                            )
                        }
                        {
                            itemObj?.param4 && itemObj?.param4?.length>0 && (
                                <div className='col-12'>
                                    <label
                                        className="form-label">
                                        {t("param.4")}
                                    </label>
                                    <span>{itemObj?.param4}</span>
                                </div>
                                
                            )
                        }
                        {
                            itemObj?.param5 && itemObj?.param5?.length>0 && (
                                <div className='col-12'>
                                    <label
                                        className="form-label">
                                        {t("param.5")}
                                    </label>
                                    <span>{itemObj?.param5}</span>
                                </div>
                                
                            )
                        }
                        {/* 堆疊追蹤 */}
                        <div className='col-12'>
                            <label
                                className="form-label">
                                {t("stack_trace")}
                            </label>
                            <span>{itemObj?.stackTrace}</span>
                        </div>
                    </div>
                  
                  
                    {JSON.stringify(expandData)!=='[]' ? (<>
                       {
                        expandData?.map((item,index)=>{
                            return (
                                <div key={index}>
                                  <hr />
                        <div className='grid'>
                            <div className='col-12 lg:col-6'>
                                <label
                                    className="form-label">
                                    {t("detail_data")}UUID
                                </label>
                                <span>{item?.txnUid}</span>
                            </div>
                            <div className='col-12 lg:col-6'>
                                <label
                                    className="form-label">
                                    {t("entity_name")}
                                </label>
                                <span>{item?.entityName}</span>
                            </div>
                            <div className='col-12 lg:col-6'>
                                <label
                                    className="form-label">
                                    {t("action")}
                                </label>
                                <span>{item?.cud}-{item?.cudName}</span>
                            </div>
                            <div className='col-12'>
                                <label
                                    className="form-label">
                                    {t("data_type.old")}
                                </label>
                                <div className='doc-code'>
                                    <div className='hover-show-panel'>
                                        <Button size='small' onClick={()=>{downloadAuditLogFile(item?.oldRowBlob,item?.txnUid+'_old_data')}} disabled={!item?.oldRowBlob} tooltip={t('button.download')} tooltipOptions={{ position: 'top' }}>
                                        <FontAwesomeIcon icon="fa-solid fa-download" />
                                        </Button>
                                    </div>
                                    <pre className='code-area'>
                                        {item?.oldRowContent}
                                    </pre>
                                </div>
                            </div>
                            <div className='col-12'>
                                <label
                                    className="form-label">
                                    {t("data_type.new")}
                                </label>
                                <div className='doc-code'>
                                    <div className='hover-show-panel'>
                                        <Button onClick={()=>{downloadAuditLogFile(item?.newRowBlob,item?.txnUid+'_new_data')}} disabled={!item?.newRowBlob} tooltip={t('button.download')} tooltipOptions={{ position: 'top' }}>
                                        <FontAwesomeIcon icon="fa-solid fa-download" />
                                        </Button>
                                    </div>
                                    <pre className='code-area'>
                                        {item?.newRowContent}
                                    </pre>
                                </div>
                            </div>
                            {
                                item?.param1 && item?.param1?.length>0 && (
                                    <div className='col-12'>
                                        <label
                                            className="form-label">
                                            {t("param.1")}
                                        </label>
                                        <span>{item?.param1}</span>
                                    </div>
                                )
                            }
                            {
                                item?.param2 && item?.param2?.length>0 && (
                                    <div className='col-12'>
                                        <label
                                            className="form-label">
                                            {t("param.2")}
                                        </label>
                                        <span>{item?.param2}</span>
                                    </div>
                                )
                            }
                            {
                                item?.param3 && item?.param3?.length>0 && (
                                    <div className='col-12'>
                                        <label
                                            className="form-label">
                                            {t("param.3")}
                                        </label>
                                        <span>{item?.param3}</span>
                                    </div>
                                )
                            }
                            {
                                item?.param4 && item?.param4?.length>0 && (
                                    <div className='col-12'>
                                        <label
                                            className="form-label">
                                            {t("param.4")}
                                        </label>
                                        <span>{item?.param4}</span>
                                    </div>
                                )
                            }
                            {
                                item?.param5 && item?.param5?.length>0 && (
                                    <div className='col-12'>
                                        <label
                                            className="form-label">
                                            {t("param.5")}
                                        </label>
                                        <span>{item?.param5}</span>
                                    </div>
                                )
                            }
                          
                             {/* 堆疊追蹤 */}
                        <div className='col-12 lg:col-4'>
                            <label
                                className="form-label">
                                {t("stack_trace")}
                            </label>
                            <span>{item?.stackTrace}</span>
                        </div>
                        </div>
                                </div>
                            )
                        })
                       }
                      
                    </>
                    ) : (<></>)
                    }
                    {/* 展開 / 收合按鈕 */}
                    <div className='grid'>
                        <div className='col-12 gap-2 flex'>
                            <Button disabled={JSON.stringify(expandData)!=='[]' || disableExpand} rounded outlined className='btn-more'
                                label={t("button.expansion")}
                                size="small"
                                type='button'
                                onClick={()=>{btnExpandDetail();}}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AccountActivityDetail;